import React from 'react';
import ReactDOM from 'react-dom';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';

class SMReservationBaseView extends SMDashboardBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      display: this.props.display,
      page: this.props.page,
      listItems: [],
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  sizeToFit() {
    if (this.state.display == SMConst.Display.Visible) {
      let $mainTable = $("#js-split_view-main");
      let $mainTableFooter = $(ReactDOM.findDOMNode(this.refs.mainTableFooter));
      $mainTableFooter.outerWidth($mainTable.outerWidth());
      
      if (!SMAppHelper.isMobile() && this.refs.scroller) {
        let $scroller = $(this.refs.scroller);
        let $footer = $('#js-dashboard-footer');
        $scroller.outerHeight($(window).outerHeight() - $scroller.offset().top - $footer.outerHeight());
      }
    }
  }
  
  componentWillReceiveProps(nextProps) {
    let newState = this.state;
    if (this.props.reservation !== nextProps.reservation){
      if (nextProps.reservation == null) {
        newState.display = SMConst.Display.Init;
      }
    }
    if (this.props.display !== nextProps.display){
      newState.display = nextProps.display;
    }
    this.setState(newState);
  }
  
  componentDidUpdate(prevProps, prevState) {
    this.sizeToFit();
    if (this.props.shouldShowReview) {
      this.scrollToReview();
    }
  }
  
  showReviewFormActionDidSelect(e) {
    e.preventDefault();
    this.scrollToReview();
  }
  
  scrollToReview(e) {
    if (this.refs.reviewTop) {
      let $scroller = SMAppHelper.isMobile() ? $("html,body") : $(this.refs.scroller);
      $scroller.animate({scrollTop: $(this.refs.reviewTop).offset().top}, "slow");
    }
  }
}
export default SMReservationBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationBaseView.jsx